import { ELSCommonUIConstants } from 'components/common';
import { ROUTE_ROLES } from 'constants/app.constant';
import React, { lazy } from 'react';
import { DP_PAGE_NAMES, DP_PATHS, DP_PRODUCT_NAME } from '../constants/dp.constant';
import DPRouteGuard from './DPRouteGuard';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
// Wrap lazy-loaded component with DPRouteGuard, capturing analytics data at definition time
// so it is available even after wrapRouteWithAnalytics strips route.data (preventing duplicate
// newPage events from the library's withLocationChangeAnalytics HOC).
var withDPGuard = function (importFn, aaData) {
    var LazyComponent = lazy(importFn);
    var WrappedComponent = function (props) { return (<DPRouteGuard aaData={aaData}>
      <LazyComponent {...props}/>
    </DPRouteGuard>); };
    WrappedComponent.displayName = 'DPGuardedComponent';
    return WrappedComponent;
};
export var DpRoutes = {
    getRoutes: function () { return [
        {
            path: DP_PATHS.welcome,
            component: withDPGuard(function () { return import(/* webpackChunkName: "DPHome" */ 'reports/dp/components/pages/dp-home/DPHome'); }, {
                analytics: { pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats, pageName: DP_PAGE_NAMES.LEADERSHIP_WELCOME, pageProductName: DP_PRODUCT_NAME }
            }),
            isPrivate: true,
            roles: INSTRUCTOR,
            exact: true
        },
        {
            path: DP_PATHS.dashboard,
            exact: true,
            component: withDPGuard(function () { return import(/* webpackChunkName: "DPDashboard" */ '../components/pages/dp-dashboard/DPDashboard'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: DP_PATHS.cohorts,
            exact: true,
            component: withDPGuard(function () { return import(/* webpackChunkName: "DPCohortList" */ '../components/pages/dp-cohorts/DPCohortList'); }, {
                analytics: { pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats, pageName: DP_PAGE_NAMES.COHORT_LIST, pageProductName: DP_PRODUCT_NAME }
            }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: DP_PATHS.thresholds,
            exact: true,
            component: withDPGuard(function () { return import(/* webpackChunkName: "DPThresholds" */ '../components/pages/dp-thresholds/DPThresholds'); }, {
                analytics: { pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats, pageName: DP_PAGE_NAMES.CUSTOM_THRESHOLD, pageProductName: DP_PRODUCT_NAME }
            }),
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ]; }
};
